module.exports = __webpack_public_path__ + "assets/img/router_before_each.65218c27.jpg";